<template>
  <v-form @submit.prevent="addEditSchedules" ref="form">
    <v-card dense style="border-radius:4px;">
        <v-toolbar flat height="45px">
            <span class="font-weight-bold ">{{action}} Workshift</span>
            <v-spacer></v-spacer>
            <help-link appId="settings" pageId="workshifts" color="black"></help-link>
            <v-btn icon @click.native="closeDialog" :disabled="disabled">
                <v-icon >close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text dense>
            <v-layout row wrap>
              <v-flex xs12 sm12 class="form-items">
                <v-alert v-if="hasAssigned" :value="true" color="red" outline style="margin-top:-5px;">
                  <b>Warning</b>: This shift is already assigned to employees. Changes may affect payroll calculations such as overtime and undertime.
                </v-alert>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <p v-if="error" style="color:red;">{{ errorMessage }}</p>
              <v-flex xs12 sm12 class="form-items">  
                <v-text-field label="Description" 
                    v-model="name" 
                    :rules="[rules.required]" 
                ></v-text-field>   
              </v-flex>
            </v-layout>    
            <v-layout row wrap style="padding: 0px 20px 20px 20px" >  
              <v-flex>
                <div class="workshift-color-box" :style="`background-color:${getWorkshiftColor}`" @click="dialogColorPicker=true">
                  <span :style="`color:${noSelectedColorFont}`">{{ colorAddText }}</span>
                </div>
              </v-flex>           
            </v-layout>         
            <v-layout row wrap>
              <v-flex xs12 sm6 class="form-items">
                  <v-menu
                      ref="menuClockStart"
                      v-model="menuClockStart"
                      :close-on-content-click="false"
                      :return-value.sync="timeClockStart"
                      lazy
                      transition="scale-transition"
                  >
                      <template v-slot:activator="{ on }">
                      <v-text-field
                          v-model="timeClockStart"
                          label="Clock Start"
                          readonly
                          v-on="on"
                          :rules="[rules.required]" 
                          @blur="computeTotalHours"
                      ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="menuClockStart"
                        v-model="timeClockStart"
                        :landscape="isMobile?false:true"
                        @click:minute="$refs.menuClockStart.save(timeClockStart)"
                      ></v-time-picker>
                  </v-menu>
                </v-flex>
                 <v-flex xs12 sm6 class="form-items">
                  <v-menu
                      ref="menuClockEnd"
                      v-model="menuClockEnd"
                      :close-on-content-click="false"
                      :return-value.sync="timeClockEnd"
                      lazy
                      transition="scale-transition"
                  >
                      <template v-slot:activator="{ on }">
                      <v-text-field
                          v-model="timeClockEnd"
                          label="Clock End"
                          readonly
                          v-on="on"
                          :rules="[rules.required]" 
                          @blur="computeTotalHours"
                      ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="menuClockEnd"
                        v-model="timeClockEnd"
                        :landscape="isMobile?false:true"
                        @click:minute="$refs.menuClockEnd.save(timeClockEnd)"
                      ></v-time-picker>
                  </v-menu>
              </v-flex>
            </v-layout>            
            <v-layout row>  
              <v-flex xs6 style="margin: 0px 10px 0px 20px">
                <v-text-field label="Break time (in minutes)" 
                    v-model="breakTime" 
                    :rules="[rules.required]" 
                    type="number"
                    mask="###"
                    @keyup="computeTotalHours"
                ></v-text-field>
              </v-flex> 
              <v-flex xs6 style="margin: 0px 20px 0px 10px">
                <v-select
                  v-model="attendanceType"
                  :items="attendanceTypes"
                  label="Attendance Type"
                  :rules="[rules.required]"
                  ></v-select>
              </v-flex>      
            </v-layout>
            <v-layout v-if="attendanceType=='Flexible'" row wrap class="form-items">  
              <v-flex style="margin:-20px 0px 20px 0px;">
                <v-switch
                  v-model="validateUndertime"
                  label="Validate Undertime"
                  color="primary"
                  persistent-hint
                  :hint="validateUndertime?'Undertime will be deducted from payroll.':'Undertime will NOT be deducted from payroll.'"
                ></v-switch> 
              </v-flex>           
            </v-layout>
            <v-layout v-if="attendanceType=='Strict'" row wrap class="form-items">  
              <v-flex style="margin-top:-10px;">
                <v-text-field label="Late grace period (in minutes)" 
                    v-model="gracePeriod" 
                    :rules="[rules.required]" 
                    type="number"
                    mask="##"
                ></v-text-field>
              </v-flex>           
            </v-layout>
            <v-layout row wrap class="form-items" style="">  
              <v-flex xs6>
                Total Hours: <b>{{totalHours}}</b>
              </v-flex>    
              <v-flex xs6>
                Chargeable Hours: <b>{{chargeableHours}}</b>
              </v-flex>           
            </v-layout>
        </v-card-text>  
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="!hasAssigned&&isUpdating" title="Delete" class="red" dark @click="dialogOkCancel=true" :loading="loading_delete">Delete</v-btn>
          <v-btn color="primary" type="submit" :loading="loading" style="color:white;margin-right:25px;">{{ action }}</v-btn>
        </v-card-actions>
    </v-card>
    <v-dialog v-model="dialogColorPicker" persistent width="790">
      <color-picker ref="addEditSchedule" :dialogColorPicker.sync="dialogColorPicker" @send="setWorkshiftColor"></color-picker>
    </v-dialog>
    <v-dialog v-model="dialogOkCancel" persistent width="600">
      <ok-cancel :msg="dialogOkCancelMsg" :dialogOkCancel.sync="dialogOkCancel" @ok="deleteWorkshift"></ok-cancel>
    </v-dialog>
  </v-form>
</template>
<script>
  import workShiftsApi from '@/api/workshift'
  export default {
    components: {
      'help-link': () => import('@/components/Common/HelpLink'),
      'color-picker': () => import('@/components/Common/ColorPicker'),
      'ok-cancel': ()=> import("@/components/BasicPopups/OkCancel"),
    },
    data () {
      return {
        action: '',      
        workShiftId: 0,
        name: '',
        rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters'
        },
        loading: false,  
        loading_delete: false,    
        dialogOkCancel: false, 
        dialogOkCancelMsg: 'This action will delete this work shift.<br> Do you want to proceed?',
        disabled: false,
        menuClockStart: false,
        timeClockStart: null,
        menuClockEnd: false,
        timeClockEnd: null,
        startDate: new Date().toISOString().substr(0, 10),
        menuStartDate: false,
        endDate: new Date().toISOString().substr(0, 10),
        menuEndDate: false,
        schedule: 0,
        error: false,
        errorMessage: '',
        strictAttendance: 0,
        breakTime: null,
        attendanceTypes: [
          {id: 0, text: 'Strict'},
          {id: 1, text: 'Flexible'}
        ],
        gracePeriod: null,
        attendanceType: null,
        chargeableHours: null,
        workshiftColor: null, 
        validateUndertime: false,
        noColorEntered: false,
        totalHours: null,
        dialogColorPicker: false,
        totalAssigned: 0,
      }
    },    
    methods: {     
      async deleteWorkshift() {
        try {
          this.dialogOkCancel = false
          this.loading_delete = true
          const data = {
            workShiftId: this.workShiftId
          }
          const response = await workShiftsApi.delete(data)
          if (response && response.status == 200) {
            this.$emit('send',null)
            this.closeDialog()
          }
          this.loading_delete = false
        }catch(error){
          this.error = true
          this.errorMessage = error
        }
      },  
      computeTotalHours() {
        if (this.timeClockStart!=null && this.timeClockEnd!=null && this.breakTime!=null) {
          var clockStart = this.$moment('1/1/1900 ' + this.timeClockStart)
          var clockEnd = this.$moment('1/1/1900 ' + this.timeClockEnd)

          if (clockStart<clockEnd) {
          
            var durationTotal = this.$moment.duration(this.$moment(clockEnd).diff(this.$moment(clockStart)))
            var durationChargeable = this.$moment.duration(this.$moment(clockEnd).add(-this.breakTime,'m').diff(this.$moment(clockStart)))

            this.totalHours = `${durationTotal.hours()}:${durationTotal.minutes()}` 
            this.chargeableHours = `${durationChargeable.hours()}:${durationChargeable.minutes()}`  
          }else{
            //night shift - clockout is on the next day
            var clockEnd = this.$moment('1/2/1900 ' + this.timeClockEnd) //plus one day if night shift

            var durationTotal = this.$moment.duration(this.$moment(clockEnd).diff(this.$moment(clockStart)))
            var durationChargeable = this.$moment.duration(this.$moment(clockEnd).add(-this.breakTime,'m').diff(this.$moment(clockStart)))

            this.totalHours = `${durationTotal.hours()}:${durationTotal.minutes()}` 
            this.chargeableHours = `${durationChargeable.hours()}:${durationChargeable.minutes()}`  
          }
        }
      },
      viewEventForAdd() {
        this.clearForm()
        this.action = 'Add'
        this.workShiftId = 0
        this.clearForm()
        this.gracePeriod = null
      },
      viewEventForEdit(data) {
        this.action = 'Update'
        this.workShiftId = data.workShiftId
        this.totalAssigned = data.totalAssigned
        this.name = data.name
        this.breakTime = data.breakTime
        this.gracePeriod = data.gracePeriod
        this.workshiftColor = data.color
        this.validateUndertime = data.validateUndertime
        this.timeClockStart = this.$moment(data.clockStart).format("H:mm")
        this.timeClockEnd = this.$moment(data.clockEnd).format("H:mm")  
        this.attendanceType = data.strict == 1 ? 'Strict' : 'Flexible'      
        this.computeTotalHours()
      },
      clearForm() {
        this.$refs.form.reset()
        this.totalHours = null
        this.chargeableHours = null
        this.noColorEntered = false
        this.workshiftColor = null
        this.loading = false
        this.error = false
        this.totalAssigned = 0
      },
      async addEditSchedules() {
          try {
            this.noColorEntered = this.workshiftColor == null
            if (this.$refs.form.validate() && this.workshiftColor != null) {

              this.loading = true
              const data = {
                  workShiftId: this.workShiftId,
                  name: this.name,
                  clockStart: this.timeClockStart,
                  clockEnd: this.timeClockEnd,
                  breakTime: this.breakTime,
                  gracePeriod: this.gracePeriod,
                  strict: this.attendanceType == 'Strict' ? 1 : 0,
                  color: this.workshiftColor,
                  validateUndertime: this.validateUndertime,
                  createdBy: 0,
                  updatedBy: 0
              }
              const response = await workShiftsApi.addupdate(data)
              if (response && response.status == 200) {
                  this.clearForm()
                  this.$emit('send',null)  
                  this.loading = false
              }
            }
          }catch(error){
            this.error = true
            this.errorMessage = error
          }
      },
      setWorkshiftColor(color){
        this.workshiftColor = color
      },
      closeDialog() {
        this.$emit('update:dialogAdd', false)
      }
    },
    created() {},
    computed: {
      isMobile() {
        return window.innerWidth < 600
      },
      hasAssigned() {
        return parseInt(this.totalAssigned)>0
      },
      isUpdating() {
        return this.action === 'Update'
      },
      noSelectedColorFont() {
        return this.noColorEntered ? 'red' : ''
      },
      getWorkshiftColor() {
        return this.workshiftColor ? this.workshiftColor : 'transparent'
      },
      colorAddText() {
        return this.workshiftColor ? 'Click to change workshift color' : 'Click to set workshift color'
      }
    }
  }
</script>
<style scoped>
.workshift-color-box {
  width: 100%;
  cursor: pointer;
  padding: 5px;
  margin-top:3px;
}
.form-items {
  padding: 0px 20px 0px 20px;
}
</style>